import { _ as _defineProperty } from './_rollupPluginBabelHelpers-b1794394.js';

var _LEVEL_DEBUG$LEVEL_IN;

var LEVEL_DEBUG = 'debug';
var LEVEL_INFO = 'info';
var LEVEL_WARN = 'warn';
var LEVEL_ERROR = 'error';
var LEVEL_CRITICAL = 'critical';
var constants = (_LEVEL_DEBUG$LEVEL_IN = {}, _defineProperty(_LEVEL_DEBUG$LEVEL_IN, LEVEL_DEBUG, 1), _defineProperty(_LEVEL_DEBUG$LEVEL_IN, LEVEL_INFO, 2), _defineProperty(_LEVEL_DEBUG$LEVEL_IN, LEVEL_WARN, 3), _defineProperty(_LEVEL_DEBUG$LEVEL_IN, LEVEL_ERROR, 4), _defineProperty(_LEVEL_DEBUG$LEVEL_IN, LEVEL_CRITICAL, 5), _LEVEL_DEBUG$LEVEL_IN);

export { LEVEL_CRITICAL, LEVEL_DEBUG, LEVEL_ERROR, LEVEL_INFO, LEVEL_WARN, constants as default };
//# sourceMappingURL=constant.js.map
